var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.modalComponent)?_c('div',[_c(_vm.modalComponent,_vm._b({tag:"component",attrs:{"show":_vm.shouldShow},on:{"cancel":function($event){return _vm.toggleState(_vm.activeModalKey)},"save":function($event){return _vm.toggleState(_vm.activeModalKey)}}},'component',_vm.modalProps,false))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }